// Libs
import {
  MESSAGE_RSOCKET_ROUTING,
  encodeAndAddCustomMetadata, encodeAndAddWellKnownMetadata
} from "rsocket-core";

/**
 * Encodes bearer token to buffer
 * @param token the token to encode
 * @returns the buffer
 */
export const encodeBearerToken = (token: string): Buffer => {
  const buffer = Buffer.alloc(1 + token.length);

  buffer.writeUInt8(1 | 0x80, 0);
  buffer.write(token, 1, "utf-8");

  return buffer;
}

/**
 * Encodes route to buffer
 * @param route the route to encode
 * @returns the buffer
 */
export const encodeRoute = (route: string): Buffer => {
  const length = Buffer.byteLength(route, 'utf8');
  const buffer = Buffer.alloc(1);

  buffer.writeInt8(length);

  return Buffer.concat([buffer, Buffer.from(route, 'utf8')]);
}

/**
 * Builds metadata for rsocket payload configuration
 * @param route 
 * @param token 
 * @returns 
 */
export const buildMetadata = (token: string, route?: string): Buffer => {
  let metadata = Buffer.alloc(0);

  metadata = encodeAndAddCustomMetadata(
      metadata,
      "message/x.rsocket.authentication.bearer.v0",
      encodeBearerToken(token),
  );

  if (route) {
      metadata = encodeAndAddWellKnownMetadata(
          metadata,
          MESSAGE_RSOCKET_ROUTING.string,
          encodeRoute(route)
      );
  }

  return metadata;
}